import angular from 'angular';

let minPatternValidator = (name, pattern) => () => ({
  require: 'ngModel',
  link(scope, element, attrs, ctrl) {
    let min = null;

    return (ctrl.$validators[name] = function(modelValue, viewValue) {
      let result;
      min = scope.$eval(attrs[name]);
      if (min < 1 || ctrl.$isEmpty(viewValue)) {
        result = true;
      } else {
        let regexp = new RegExp(pattern, 'g');
        for (
          let i = 1, end = min, asc = 1 <= end;
          asc ? i <= end : i >= end;
          asc ? i++ : i--
        ) {
          result = regexp.test(viewValue);
        }
      }

      return result;
    });
  },
});

let mod = angular
  .module('app.validators.minPattern', [])
  .directive('mindigits', minPatternValidator('mindigits', '\\d'))
  .directive('minletters', minPatternValidator('minletters', '[a-zA-Z]'));

export default mod;
